export const COUNTRY_CONFIGS = {
  NG: {
    code: "+234",
    pattern: /^[789][01]\d{7,8}$/,
    localPrefix: "0",
    name: "Nigeria",
  },
  US: {
    code: "+1",
    pattern: /^[2-9]\d{2}[2-9]\d{2}\d{4}$/,
    localPrefix: "",
    name: "United States",
  },
  GB: {
    code: "+44",
    pattern: /^[1-9]\d{8,9}$/,
    localPrefix: "0",
    name: "United Kingdom",
  },
  IN: { code: "+91", pattern: /^[6-9]\d{9}$/, localPrefix: "", name: "India" },
  CA: {
    code: "+1",
    pattern: /^[2-9]\d{2}[2-9]\d{2}\d{4}$/,
    localPrefix: "",
    name: "Canada",
  },
  AU: {
    code: "+61",
    pattern: /^[2-9]\d{8}$/,
    localPrefix: "0",
    name: "Australia",
  },
  ZA: {
    code: "+27",
    pattern: /^[1-9]\d{8}$/,
    localPrefix: "0",
    name: "South Africa",
  },
  KE: { code: "+254", pattern: /^[17]\d{8}$/, localPrefix: "0", name: "Kenya" },
  GH: {
    code: "+233",
    pattern: /^[235]\d{8}$/,
    localPrefix: "0",
    name: "Ghana",
  },
  EG: {
    code: "+20",
    pattern: /^1[0-5]\d{8}$/,
    localPrefix: "0",
    name: "Egypt",
  },
};